<div>
  <div style="margin-bottom: 1rem">
    <button class="button primary" type="button" (click)="create()">
      Add idol
    </button>
  </div>

  <div *ngFor="let item of idols; index as i" class="idol-container">
    <input
      class="idol-input"
      type="text"
      placeholder="Idol name"
      required
      (input)="editIdolName($event.target.value, i)"
    />
    <input
      class="num-input"
      type="number"
      placeholder="Number of winners"
      min="0"
      required
      (input)="editIdolNumOfWinner($event.target.value, i)"
    />

    <div
      *ngIf="canDelete"
      class="delete-icon"
      [style.visibility]="idols.length > 1 ? 'visible' : 'hidden'"
      (click)="deleteIdol(i)"
    >
      <clr-icon shape="times" size="24"></clr-icon>
    </div>
  </div>
</div>
